document.addEventListener('DOMContentLoaded', () => {
    let searchBars = document.querySelectorAll('.search-trigger');
    let resultsWrapper = document.querySelector('.predictive-search')
    let resultsContainer = resultsWrapper.querySelector('.inner');
    const recommendedProducts = document.querySelector('.recommended-search-products');

    function handleScroll() {
        if (window.scrollY > 0) {
            resultsWrapper.classList.add('scrolled');
        } else {
            resultsWrapper.classList.remove('scrolled');
        }
    }
    window.addEventListener('load', handleScroll);
    window.addEventListener('scroll', handleScroll);




    searchBars.forEach(searchBar => {

        // Site search using predictive search api
        const predictiveSearchCallBack = () => {
            const section_name = 'gb-predictive-search';

            if(searchBar.value.length > 2){

                var requestResponse;
                fetch(`/search/suggest?q=${searchBar.value}&resources[type]=product,collection,article,page&resources[options][fields]=title,product_type,variants.sku,variants.title,tag&resources[limit_scope]=each&section_id=${section_name}`)
                .then((response) => {
                    requestResponse = response;
                    return response.text();
                })
                .then((text) => {
                    if (!requestResponse.ok) {
                    throw new Error(`${requestResponse.status}: ${text}`);
                    }
                    resultsWrapper.classList.add('active');
                    resultsWrapper.querySelector('.inner').classList.add('active');

                    const resultsMarkup = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector(`#shopify-section-${section_name}`).innerHTML;

                    resultsContainer.innerHTML = resultsMarkup;
                    recommendedProducts.style.display = 'none';

                })
                .then (() => {
                    let resultsButtons = document.querySelectorAll('.results-button');
                    if(resultsButtons){
                        resultsButtons.forEach(resultsButton => {

                                resultsButton.href = `/search?q=${searchBar.value}`;

                        });
                    }
                    window.globalListeners.disableScroll();
                })
                .catch((error) => {
                    console.error(error);
                });
            } else {
                resultsContainer.innerHTML = '';
                resultsWrapper.querySelector('.inner').classList.remove('active');
                // console.log('no results')
                recommendedProducts.style.display = 'block';
            }
        }

        let searchMethod = predictiveSearchCallBack;

        if(searchBar && resultsContainer){
            searchBar.addEventListener('keyup', searchMethod)
            let closeButton = resultsWrapper.querySelector('.close');
            if(closeButton) {
                closeButton.addEventListener('click', () => {
                    resultsWrapper.classList.remove('active');
                    window.globalListeners.enableScroll();
                })
            }
        }
    })

    const modal = document.querySelector('.predictive-search-modal');
    if (modal) {
        window.addEventListener('click', (e) => {

            if(e.target.classList.contains('predictive-search-modal')){

                resultsWrapper.classList.remove('active');
                window.globalListeners.enableScroll();
            }
        })
    }

})


